<template>
  <div
      class="store-buttons"
      v-if="!isNativePlatform"
  >
    <a
        class="badge"
        href="https://play.google.com/store/apps/details?id=nl.broodjedunner.app"
        target="_blank"
    >
      <img v-if="playStoreImage" :src="playStoreImage" alt="Badge Play Store">
    </a>

    <a
        class="badge"
        href="https://apps.apple.com/app/6741806743"
        target="_blank"
    >
      <img v-if="appStoreImage" :src="appStoreImage" alt="Badge App Store">
    </a>
  </div>
</template>

<script>
import playStore from "../../assets/images/play-store-badge.svg";
import appStore from "../../assets/images/app-store-badge.svg";
import {Capacitor} from '@capacitor/core';

export default {
  name: "StoreButtons",
  computed: {
    isNativePlatform() {
      return Capacitor.isNativePlatform();
    }
  },
  data() {
    return {
      playStoreImage: playStore,
      appStoreImage: appStore,
    };
  },
};
</script>
